<ng-container
        *ngIf="showInputs">
  <ng-container *transloco="let t; read 'home.calculator'" [formGroup]="formGroup">
    <div class="text-sm text-gray-500">
      {{t('plant_data')}}
    </div>

    <psc-input
      @inOutAnimation
      formControlName="project_name"
      [label]="t('project_name.title')"></psc-input>
    <psc-input
      @inOutAnimation
      formControlName="address"
      [label]="t('address.title')"></psc-input>
  </ng-container>
</ng-container>
